import { Component } from '@angular/core';

import { ScrollAnimateDirective } from '../../../directives/scroll-animate.directive';

@Component({
  selector: 'app-lite-detail-section',
  imports: [ScrollAnimateDirective],
  templateUrl: './lite-detail-section.html',
  styleUrl: './lite-detail-section.css',
})
export class LiteDetailSection {}
